module.exports = __webpack_public_path__ + "img/header-logo.c1acb1ab.png";